// @ vendors
const React = require('react');

// @ components
const OKModal = require('components/commons/OKModal/OKModal');

const modal = (idx, name, cancelDelete, confirmCancelDelete, deletingEstate = false) => (
    <OKModal
        content="mortgageRequestEstates-deleteText"
        footerType="navigation"
        isOpen={true}
        onCloseCallback={evt => cancelDelete(evt, null, null, false)}
        onPrimaryButtonClick={evt => confirmCancelDelete(evt, idx, name)}
        onSecondaryButtonClick={evt => cancelDelete(evt, null, null, false)}
        primaryButtonDisabled={deletingEstate}
        primaryButtonLoading={deletingEstate}
        primaryButtonText="common-accept"
        secondaryButtonText="common-cancel"
        title="mortgageRequestEstates-deleteTitle"
    />
);

module.exports = modal;
